import { useRef, useEffect } from 'react';
// @ts-expect-error highcharts@7 is not typed
import Highcharts from 'highcharts';
import { chartOptions } from './chartOptions';
import { jsx as _jsx } from "react/jsx-runtime";
Highcharts.setOptions(chartOptions);
// based on https://github.com/highcharts/highcharts-react
export const ReactHighcharts = ({
  containerProps,
  options,
  callback
}) => {
  const chart = useRef(null);
  const container = useRef(null);

  // Use ResizeObserver so that the chart also reflows when
  // the container dimensions change because of DOM updates
  // and not just window resize events
  const resizeObserver = useRef(new ResizeObserver(() => {
    if (chart.current) {
      chart.current.reflow();
    }
  }));
  const observer = resizeObserver.current;
  useEffect(() => {
    if (!options) {
      // eslint-disable-next-line no-console
      console.warn('The "options" property was not passed.');
    } else if (container.current) {
      chart.current = Highcharts.chart(container.current, options, callback);
    }

    // Observe container resizing
    if (container.current) {
      resizeObserver.current.observe(container.current);
    }

    // Cleanup
    return () => {
      if (chart.current) {
        chart.current.destroy();
        chart.current = null;
      }
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (chart.current) {
      chart.current.update(options, true, true);
    }
  }, [options]); // Update when options change

  return /*#__PURE__*/_jsx("div", Object.assign({}, containerProps, {
    ref: container
  }));
};